module.exports = __webpack_public_path__ + "img/rtf.1b148ca4.svg";